import { ReactChild } from 'react'
import styled from 'styled-components'

import { Box, Icon, LinedTitle } from 'components'
import { colors } from 'utils/colors'

type LinedAddButtonProps = {
  title: string
  activeColor: keyof typeof colors
  staleColor: keyof typeof colors
  isActive: boolean
  onClick: () => void
}

const LinedAddButton = ({ title, activeColor, staleColor, isActive, onClick }: LinedAddButtonProps) => (
  <LineButtonContainer
    display="flex"
    flexDirection="row"
    alignItems="center"
    width="100%"
    activeColor={activeColor}
    onClick={onClick}
  >
    <Icon color={isActive ? activeColor : staleColor} fontSize={24} icon={['fal', 'plus-square']} />
    {!isActive && (
      <LineWrapper className="lined-button__line--with-title">
        <LinedTitle title={title} color={activeColor} fontSize={14} fontWeight="medium" />
      </LineWrapper>
    )}
    <LineWrapper className={!isActive ? 'lined-button__line--without-title' : ''}>
      <Line color={isActive ? activeColor : staleColor} />
    </LineWrapper>
  </LineButtonContainer>
)

const LineWrapper = ({ className, children }: { className: string; children: ReactChild }) => (
  <Box className={className} width="100%">
    {children}
  </Box>
)

const LineButtonContainer = styled(Box)<{ activeColor: keyof typeof colors }>`
  .lined-button__line--with-title {
    display: none;
  }

  .lined-button__line--without-title {
    display: block;
  }

  :hover {
    cursor: pointer;

    & * {
      color: ${({ activeColor }) => colors[activeColor]};
    }

    .lined-button__line--with-title {
      display: block;
    }

    .lined-button__line--without-title {
      display: none;
    }
  }
`

const Line = styled.div`
  height: 1px;
  width: 100%;
  background: ${({ color }) => colors[color as keyof typeof colors]};
`

export default LinedAddButton
